import { ReactComponent as FlagIcon } from "./svg/cr-flag.svg";
import "../flag-icon.scss";

export const CRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
